import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=2dc3c4d0"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc3c4d0')) {
      api.createRecord('2dc3c4d0', component.options)
    } else {
      api.reload('2dc3c4d0', component.options)
    }
    module.hot.accept("./Config.vue?vue&type=template&id=2dc3c4d0", function () {
      api.rerender('2dc3c4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Formcreated/components/Config.vue"
export default component.exports